import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

import Meta from './meta';

const MetaWebsite = ({
  data,
  pageDescription = '',
  pageImage,
  pageTitle = '',
  pathname = '/',
}) => {
  const {
    defaultDescription,
    defaultLogo,
    defaultTitle,
    siteLanguage,
    siteUrl,
  } = data.site.siteMetadata;

  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    description: pageDescription || defaultDescription,
    image: {
      '@type': 'ImageObject',
      url: pageImage ? pageImage : `${siteUrl}${defaultLogo}`,
    },
    inLanguage: siteLanguage,
    name: pageTitle || defaultTitle,
    url: `${siteUrl}${pathname === '/' ? '' : pathname}`,
  };

  return (
    <>
      <Meta
        pageDescription={pageDescription}
        pageImage={pageImage}
        pageTitle={pageTitle}
        pathname={pathname}
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
    </>
  );
};

const query = graphql`
  {
    site {
      siteMetadata {
        author
        defaultDescription: description
        defaultLogo: logo
        defaultTitle: title
        facebook
        ogLanguage
        publisherLogo
        siteLanguage
        siteUrl
        twitter
      }
    }
  }
`;

MetaWebsite.propTypes = {
  pageDescription: PropTypes.string,
  pageImage: PropTypes.string,
  pageTitle: PropTypes.string,
  pathname: PropTypes.string,
};

export default (props) => (
  <StaticQuery
    query={`${query}`}
    render={(data) => <MetaWebsite data={data} {...props} />}
  />
);
